<template>
    <div class="body">
      <form @submit.prevent="register">
        <input class="hidden" type="submit" />
        <div class="form-element">
          <label for="register-email">E-mail</label>
          <input id="register-email" type="text" v-model="email" v-on:keyup="error = null" />
        </div>
        <div class="form-element">
          <label for="register-password">{{ $t('modals.register.password') }}</label>
          <input id="register-password" type="password" v-model="password" v-on:keyup="error = null" />
        </div>
        <div class="form-element">
          <label for="register-birthdate">{{ $t('modals.register.birthdate') }}</label>
          <date-button dark :date="birthdate" @change="setBirthDate"></date-button>
        </div>
        <div class="form-element">
          <label for="register-firstname">{{ $t('modals.register.firstname') }}</label>
          <input id="register-firstname" type="text" v-model="firstname" v-on:keyup="error = null" />
        </div>
        <div class="form-element">
          <label for="register-lastname">{{ $t('modals.register.lastname') }}</label>
          <input id="register-lastname" type="text" v-model="lastname" v-on:keyup="error = null" />
        </div>
        <div class="form-element">
          <label for="register-middlename">{{ $t('modals.register.middlename') }}</label>
          <input id="register-middlename" type="text" v-model="middlename" v-on:keyup="error = null" />
        </div>
        <div class="form-element">
          <label for="register-phone">{{ $t('common.phone-number') }}</label>
          <input id="register-phone" type="text" v-model="phone" />
        </div>
        <div class="form-element">
          <label for="register-currency">{{ $t('modals.register.currency') }}</label>
          <select id="register-currency" v-model="currency" class="currency" v-on:keyup="error = null" >
            <option>USD</option>
            <option>EUR</option>
            <option>RUR</option>
            <option>AZN</option>
          </select>
        </div>
        <!--div class="form-element">
          <label for="register-promo">{{ $t('modals.register.promo') }}</label>
          <input id="register-promo" class="promo" type="text" v-model="promo" v-on:keyup="error = null"/>
          <color-button class="promo-button" round color="yellow" @click="checkPromo()">{{ $t('modals.register.check') }}</color-button>
        </div>
        <div class="red-color" v-html="errorPromo" />
        <div class="success" v-html="successPromo" /-->
        <div class="red-color" v-html="error" />
        <color-button round color="yellow" @click="register">{{ $t('modals.register.submit') }}</color-button>
      </form>
    </div>
</template>

<script>
import Modal from '@/components/modals/Modal'
import DateButton from '@/components/buttons/DateButton'
import ColorButton from '@/components/buttons/ColorButton'
import AuthenticationService from '@/services/AuthenticationService'

export default {
  components: {
    Modal,
    DateButton,
    ColorButton
  },
  data () {
    return {
      email: '',
      password: '',
      birthdate: '',
      firstname: '',
      lastname: '',
      middlename: '',
      phone: '',
      currency: 'USD',
      error: null,
      errorPromo: null,
      success: null,
      successPromo: null,
      promo: null
    }
  },
  methods: {
    async register () {
      this.error = null
      try {
        const response = await AuthenticationService.register({
          email: this.email,
          password: this.password,
          birthdate: this.birthdate,
          firstname: this.firstname,
          lastname: this.lastname,
          middlename: this.middlename,
          phone: this.phone,
          currency: this.currency,
          promo: 'AZXBET'
        })
        this.$store.dispatch('setToken', response.data.token)
        this.$store.dispatch('setUser', response.data.user)
        this.$router.push('/')
      } catch (error) {
        this.error = error.response.data.error
      }
    },
    setBirthDate (date) {
      this.error = null
      this.birthdate = date
    },
    async checkPromo () {
      if (this.promo === 'AZXBET' || this.promo === 'AZXPART' || this.promo === 'AZEBONUS') {
        this.errorPromo = ''
        this.successPromo = this.$t('modals.register.success-promo-wrp')
      } else {
        this.successPromo = ''
        this.errorPromo = this.$t('modals.register.error-promo-wrp')
        this.promo = ''
      }
    }
  }
}
</script>

<style scoped>
.red-color { margin-top: 17px; }
input { height: 25px !important; line-height: 25px !important; }
.currency { border: 1px solid #a2adbf; border-radius: 3px; height: 25px; }
.country { border: 1px solid #a2adbf; border-radius: 3px; height: 25px; }
.select-bonus { border: 1px solid #a2adbf; border-radius: 3px; height: 25px; }
.rules { font-size: 11px; position: absolute; margin-left: 18px; margin-top: 8px;}
.check-rules { width: 14px; }
.promo { width: 155px; }
.promo-button { width: 154px; float: right; position: absolute; margin-top: 18px; margin-left: 156px; border-radius: 3px; height: 25px; line-height: 25px; }
.success { color: #43a047; font-weight: bold; font-size: 14px; }
.register-date { height: 25px; line-height: 25px; border: 1px solid #a2adbf; border-radius: 3px; background: white; }
.form-element { margin-bottom: 5px !important; color: white;}
.form-element-none { display: none; }
.red { color: red; }
.body {width: 410px; margin-left: 30%; margin-top: 10px; color: white; text-align: center;}
</style>



// WEBPACK FOOTER //
// src/components/register/RegisterRo.vue